import { render, staticRenderFns } from "./tab6.vue?vue&type=template&id=4f590166&scoped=true"
import script from "./tab6.vue?vue&type=script&lang=js"
export * from "./tab6.vue?vue&type=script&lang=js"
import style0 from "./tab6.vue?vue&type=style&index=0&id=4f590166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f590166",
  null
  
)

export default component.exports